module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-apache-02-m.a2949852a112b4f7f9b00fa1bf7f17ee.png";